import { PropsWithChildren, ReactNode } from "react";
import { cn } from "@shortsworks/ui/lib/utils";
import { ScrollArea } from "@shortsworks/ui";
import { useMainContext } from "@app/components/MainContainer";

interface MainContentProps extends PropsWithChildren {
  className?: string;
  disableContainerScroll?: boolean;
  enableScrollInsideContainer?: boolean;
}

export const MainContent = ({
  children,
  className,
  disableContainerScroll,
  enableScrollInsideContainer,
}: MainContentProps) => {
  useMainContext();

  const render = (comp: ReactNode) => {
    if (disableContainerScroll) {
      return <div className={cn("p-4 lg:p-6 h-full", className)}>{comp}</div>;
    } else {
      return (
        <ScrollArea className="w-full h-full">
          <div className={cn("p-4 lg:p-6", className)}>{comp}</div>
        </ScrollArea>
      );
    }
  };

  return (
    <div className={cn("flex flex-1 flex-col overflow-hidden", className)}>
      {render(
        <div
          className={cn(
            "flex flex-col w-full h-full",
            "space-y-6",
            !disableContainerScroll && "pb-16",
          )}
        >
          <div
            className={cn(
              "w-full h-full",
              enableScrollInsideContainer && "overflow-hidden",
            )}
          >
            {children}
          </div>
        </div>,
      )}
    </div>
  );
};
